import { Suspense } from "react";
import React, { useEffect, useState } from "react";
import "./Users.css";
import { Checkbox, Select } from "antd";
import "react-multi-date-picker/styles/colors/green.css";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { validNationalCode, validNightNumber } from "../../Regex";
import { validPhoneNumber } from "../../Regex";
import { useUserActions } from "./connectApi/users";
import CreateTeammateUser from "./CreateTeammateUser";
import { useLocations } from "../CityProvinceManagement/connectApi/location";
import { notification } from "antd";
import { Modal } from "antd";
import Mapir from "mapir-react-component";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/Loader/Loder";
import { useSubscriptions } from "../Subscriptions/fetchApi";
function CreateNewUser(props) {


  const navigate = useNavigate();
  const Map = Mapir.setToken({
    transformRequest: (url) => {
      return {
        url: url,
        headers: {
          "x-api-key":
            "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjBlOTc1MWVjNTZiYjM1MjQwODA2MzdkYjM2YzJlODk3NmQxOTExNzFkNWU2YWEzY2RjYmQwOTE3N2NlYTFjMGY0ZmVkMGI3NTIzOWUxNGFmIn0.eyJhdWQiOiIyNjkyMSIsImp0aSI6IjBlOTc1MWVjNTZiYjM1MjQwODA2MzdkYjM2YzJlODk3NmQxOTExNzFkNWU2YWEzY2RjYmQwOTE3N2NlYTFjMGY0ZmVkMGI3NTIzOWUxNGFmIiwiaWF0IjoxNzEyOTIwMzkxLCJuYmYiOjE3MTI5MjAzOTEsImV4cCI6MTcxNTUxMjM5MSwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.Oqa9Gh--45ZwNG9ZTMsblE8QPK_NZaKXNrfD62_K_buuLUBln3GHaIQHxmGzCjO8jflBMCem23BgbEyGnL_opz--LXbw0lkigQecfcBRjTKCvqOA8cVqhNqL86LNMLwQgr1vEL92YqoI3cQz0OMqBvNEroFari5ObZXOamPK2WbiomYw68fZH2oahGwiMZUmuibkaODZVXOxLMApiHRhFc0u_Q9GlUzf67Ovi4WDaniXZ4AtHN5CJjPRRZQzK7EoGKjrWXvLdhi_yTQubH5Qx-XNsiRPIR8RgdhjOuoWytunfOnT5gUYzMhhFlJ_n307oD7QeEPb6hVtTfotWp3G1w", //Mapir api key
          "Mapir-SDK": "reactjs",
        },
      };
    },
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const userInfo = useUserActions((state) => state.userInfo)

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const [selectedLocation, setSelectedLocation] = useState();
  const [markerArray, setMarkerArray] = useState([]);
  const [coord, setCoord] = useState([51.42, 35.72]);
  function reverseFunction(map, e) {
    var url = `https://map.ir/reverse/no?lat=${e.lngLat.lat}&lon=${e.lngLat.lng}`;
    fetch(url, {
      headers: {
        "Content-Type": "application/json",
        "x-api-key":
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjBlOTc1MWVjNTZiYjM1MjQwODA2MzdkYjM2YzJlODk3NmQxOTExNzFkNWU2YWEzY2RjYmQwOTE3N2NlYTFjMGY0ZmVkMGI3NTIzOWUxNGFmIn0.eyJhdWQiOiIyNjkyMSIsImp0aSI6IjBlOTc1MWVjNTZiYjM1MjQwODA2MzdkYjM2YzJlODk3NmQxOTExNzFkNWU2YWEzY2RjYmQwOTE3N2NlYTFjMGY0ZmVkMGI3NTIzOWUxNGFmIiwiaWF0IjoxNzEyOTIwMzkxLCJuYmYiOjE3MTI5MjAzOTEsImV4cCI6MTcxNTUxMjM5MSwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.Oqa9Gh--45ZwNG9ZTMsblE8QPK_NZaKXNrfD62_K_buuLUBln3GHaIQHxmGzCjO8jflBMCem23BgbEyGnL_opz--LXbw0lkigQecfcBRjTKCvqOA8cVqhNqL86LNMLwQgr1vEL92YqoI3cQz0OMqBvNEroFari5ObZXOamPK2WbiomYw68fZH2oahGwiMZUmuibkaODZVXOxLMApiHRhFc0u_Q9GlUzf67Ovi4WDaniXZ4AtHN5CJjPRRZQzK7EoGKjrWXvLdhi_yTQubH5Qx-XNsiRPIR8RgdhjOuoWytunfOnT5gUYzMhhFlJ_n307oD7QeEPb6hVtTfotWp3G1w",
      },
    })
      .then((response) => response.json())
      .then((data) => setSelectedLocation(data));
    const array = [];
    array.push(
      <Mapir.Marker
        coordinates={[e.lngLat.lng, e.lngLat.lat]}
        anchor="bottom"
      />
    );
    setMarkerArray(array);
  }

  const countries = useLocations((state) => state.countryes);
  const provinceByParentId = useLocations((state) => state.provinceByParentId);




  const [showMore, setShowMore] = useState(false);
  const [activeStatus, setActiveStatus] = useState(1);
  const status = [
    { id: 1, title: "همکار" },
    { id: 2, title: "کاربر" },
  ];

  const { getOneCity, getOneProvince } = useLocations((state) => state.actions);


  const [selectedCountry, setSelectedCountry] = useState();
  const [selectedProvince, setSelectedProvince] = useState();
  const [selectedCity, setSelectedCity] = useState();

  const { createUser, saveUserProfilelImage, editAddUser } = useUserActions(
    (state) => state.actions
  );
  const cityByParentId = useLocations((state) => state.cityByParentId);
  const userInit = useSubscriptions((state) => state.userInit);
  const [profileName, setProfileName] = useState();
  const seveProfilePhotoHandler = (e) => {
    setFile(URL.createObjectURL(e.target.files[0]));
    setProfileName(e.target.files[0]);
  };
  const [file, setFile] = useState();
  const convertNumbers2English = (string) => {
    return string.replace(/[\u0660-\u0669]/g, function (c) {
      return c.charCodeAt(0) - 0x0660;
    }).replace(/[\u06f0-\u06f9]/g, function (c) {
      return c.charCodeAt(0) - 0x06f0;
    });
  }
  useEffect(() => {
    if (userInfo) {
      if (profileName) {
        saveUserProfilelImage(
          userInfo.id,
          profileName
        );
      }
    }
  }, [userInfo])
  console.log(userInit?.userTypeCode, "userInit in CreateNewUser");

  const filteredStatus = userInit?.userTypeCode == 5
  ? status.filter(item => item.id !== 2)
  : status;


  return (
    <>

      <Suspense fallback={<Loader />}>
        <div className="">
          <div>
            <p className="font-bold text-center my-4">ایجاد کاربر جدید</p>
            <div className="flex items-center justify-center gap-6 mb-8">
              {filteredStatus.map((item) => (
                <button
                  onClick={() => setActiveStatus(item.id)}
                  className={`transition-all ${activeStatus === item.id
                    ? "border-red-500 text-red-600 "
                    : "border-gray-400"
                    }  border-2 rounded text-center w-[40%] py-1`}
                >
                  {item.title}
                </button>
              ))}
            </div>
            {activeStatus === 1 ? (
              <CreateTeammateUser />
            ) : (
              <>
                <Formik
                  initialValues={{
                    name: "",
                    lastName: "",
                    phone: "",
                    code: "",
                    country: "",
                    city: "",
                    province: "",
                    address: "",
                    nationalCode: "",
                    businessExpertise: "",
                    businessAccountName: "",
                    email: "",
                    cardNumber: "",
                    nightNumber: "",
                    rol: "",
                    picProfile: "",
                    businessType: "",
                    adsMainCategoryCode: 0,
                    descraption: ""
                  }}
                  validate={(values) => {
                    const errors = {};
                    if (values.phone.length < 10) {
                      errors.phone = "شماره همراه معتبر نمیباشد";
                    } else if (!validPhoneNumber.test(values.phone)) {
                      errors.phone = "شماره همراه وارد شده نامعتبر میباشد";
                    } else if (values.code.length < 4) {
                      errors.code = "کد تایید وارد شده نامعتبر میباشد";
                    } else if (!values.country) {
                      errors.country = "کشور را انتخاب کنید";
                    } else if (!values.province) {
                      errors.province = "استان را انتخاب کنید";
                    } else if (!values.city) {
                      errors.city = "شهر را انتخاب کنید";
                    }

                    // if (showMore) {
                    //   if (values.name.length < 3) {
                    //     errors.name = "این فیلد اجباری میباشد";
                    //   } else if (values.lastName.length < 10) {
                    //     errors.lastName = "این فیلد اجباری میباشد";
                    //   } else if (values.businessType.length < 5) {
                    //     errors.businessType = "نوع کسب و کار نامعتبر است";
                    //   } else if (values.businessExpertise.length < 5) {
                    //     errors.businessExpertise = "تخصص کسب و کار نامعتبر است";
                    //   } else if (values.businessAccountName.length < 5) {
                    //     errors.businessAccountName =
                    //       "نام کسب و کار نامعتبر است";
                    //   } else if (!validNationalCode.test(values.nationalCode)) {
                    //     errors.nationalCode = "کدملی وارد شده نامعتبر میباشد";
                    //   }
                    // }

                    return errors;
                  }}
                  onSubmit={async (values, event, errors) => {
                    if (!errors) {
                      await editAddUser(
                          /* id */ 0,
                /* lastUserId,*/ 0,
                /* firstName,*/  values.name,
                /* lastName,*/ values.lastName,
                /* businessExpertise,*/ values.businessExpertise,
                /* businessAccountName,*/ "",
                /* adsMainCategoryCode,*/ values.adsMainCategoryCode,
                /* nationalCode,*/  values.nationalCode,
                /* email,*/ "mail.com",
                /* gender,*/ null,
                /* mobileNumber,*/ values.phone,
                /* phoneNumber,*/ values.fixedPhone,
                /* emergencyNumber,*/ values.fixedPhonEemergency,
                /* birthDate,*/ null,
                /* country,*/ 1,
                /* state,*/ 2,
                /* city,*/ 3,
                /* longitudes,*/ 0,
                /* latitudes,*/ 0,
                /* address,*/  values.address,
                /* isBusinessUser,*/ showMore,
                /* description,*/ values.descraption,
                /* perssonelPicUrl,*/ null,
                /* businessLicensePicUrl,*/ null,
                /* shPicUrl,*/ null,
                /* otherDocumnetUrl,*/ null,
                /* nationalCardPicUrl,*/ null,
                /* positionCode,*/ 0,
                /* businessLicenseNumber,*/ null,
                /* instagramId,*/ null,
                /* telegramId,*/ null,
                /* userTypeCode,*/ 2,
                /* userRegisterStatusCode,*/ 1,
                /* isUpdated,*/ false,
                /* isShowPhoneNumber,*/ false,
                /* isChatEnable*/ false
                      );

                      // openNotification();
                      // navigate("/usersList");
                    } else formNotCompleted();
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                  }) => (
                    <Form
                      onSubmit={handleSubmit}
                      className={`flex flex-col gap-4 mt-4 fade-in-b `}
                    >
                      <div className="grid grid-cols-4 gap-4 py-2 xl:grid-cols-2 2xl:grid-cols-3">
                        <div className="flex flex-col ">
                          <label htmlFor="name">نام </label>
                          <Field
                            type="text"
                            name="name"
                            className="border-none outline-none bg-gray-100 p-1 rounded-xl"
                          />
                          <ErrorMessage name="name">
                            {(msg) => (
                              <div className="text-[11px] text-red-600 pr-2">
                                {msg}
                              </div>
                            )}
                          </ErrorMessage>
                        </div>
                        <div className="flex flex-col ">
                          <label htmlFor="lastName">نام خانوادگی </label>
                          <Field
                            type="text"
                            name="lastName"
                            className="border-none outline-none bg-gray-100 p-1 rounded-xl"
                          />
                          <ErrorMessage name="name">
                            {(msg) => (
                              <div className="text-[11px] text-red-600 pr-2">
                                {msg}
                              </div>
                            )}
                          </ErrorMessage>
                        </div>
                        <div className="flex flex-col border-none outline-none  p-1 rounded-xl items-">
                          <label htmlFor="phone">شماره همراه *</label>
                          <div className="bg-gray-100 p-1 rounded-xl flex gap-0 items-center justify-between">
                            <Field
                              type="text"
                              name="phone"
                              className="border-none outline-none  bg-transparent w-[200px] direction"
                            />
                            <button
                              type="button"
                              className="text-green-600 text-[10px]"
                            >
                              ارسال کد تایید
                            </button>
                          </div>
                          <ErrorMessage name="phone">
                            {(msg) => (
                              <div className="text-[11px] text-red-600 pr-2">
                                {msg}
                              </div>
                            )}
                          </ErrorMessage>
                        </div>
                        <div className="flex flex-col ">
                          <label htmlFor="code">کد تایید پیامکی *</label>
                          <div className="bg-gray-100 p-1 rounded-xl flex items-center justify-between">
                            <Field
                              type="text"
                              name="code"
                              className="border-none outline-none bg-transparent "
                            />
                            <div className={`opacity-25 `}>
                              <img
                                src="./icons/tik.svg"
                                alt="ok"
                                className={`w-[18px] `}
                              />
                            </div>
                          </div>
                          <ErrorMessage name="code">
                            {(msg) => (
                              <div className="text-[11px] text-red-600 pr-2">
                                {msg}
                              </div>
                            )}
                          </ErrorMessage>
                        </div>
                      </div>
                      <div className="grid grid-cols-3 gap-4 py-2 place-items-stretch items-center pb-8">
                        <div className="flex flex-col  ">
                          <label htmlFor="country">کشور *</label>
                          <Select
                            onChange={async (e) => {
                              getOneProvince(e);
                              setSelectedCountry(e);
                              values.country = e;
                            }}
                            defaultOpen={false}
                            showSearch
                            placeholder=""
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              (option?.label ?? "").includes(input)
                            }
                            filterSort={(optionA, optionB) =>
                              (optionA?.label ?? "")
                                .toLowerCase()
                                .localeCompare(
                                  (optionB?.label ?? "").toLowerCase()
                                )
                            }
                          >
                            {countries
                              ? countries.map((item) => (
                                <Select.Option key={item.id} value={item.id}>
                                  <span>{item.locName}</span>
                                </Select.Option>
                              ))
                              : ""}
                          </Select>
                          <ErrorMessage name="country">
                            {(msg) => (
                              <div className="text-[11px] text-red-600 pr-2">
                                {msg}
                              </div>
                            )}
                          </ErrorMessage>
                        </div>
                        <div
                          className={`flex flex-col ${provinceByParentId.length
                            ? "pointer-events-auto opacity-100"
                            : "pointer-events-none opacity-50"
                            }`}
                        >
                          <label htmlFor="province">استان *</label>
                          <Select
                            defaultOpen={false}
                            showSearch
                            placeholder=""
                            onChange={(e) => {
                              getOneCity(e);
                              setSelectedProvince(e);
                              values.province = e;
                            }}
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              (option?.label ?? "").includes(input)
                            }
                            filterSort={(optionA, optionB) =>
                              (optionA?.label ?? "")
                                .toLowerCase()
                                .localeCompare(
                                  (optionB?.label ?? "").toLowerCase()
                                )
                            }
                          >
                            {provinceByParentId
                              ? provinceByParentId.map((item) => (
                                <Select.Option key={item.id} value={item.id}>
                                  <span>{item.locName}</span>
                                </Select.Option>
                              ))
                              : ""}
                          </Select>
                          <ErrorMessage name="province">
                            {(msg) => (
                              <div className="text-[11px] text-red-600 pr-2">
                                {msg}
                              </div>
                            )}
                          </ErrorMessage>
                        </div>
                        <div
                          className={`flex flex-col ${cityByParentId.length
                            ? "pointer-events-auto opacity-100"
                            : "pointer-events-none opacity-50"
                            }`}
                        >
                          <label htmlFor="city">شهر *</label>
                          <Select
                            defaultOpen={false}
                            onChange={(e) => {
                              setSelectedCity(e);
                              values.city = e;
                            }}
                            showSearch
                            placeholder=""
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              (option?.label ?? "").includes(input)
                            }
                            filterSort={(optionA, optionB) =>
                              (optionA?.label ?? "")
                                .toLowerCase()
                                .localeCompare(
                                  (optionB?.label ?? "").toLowerCase()
                                )
                            }
                          >
                            {cityByParentId.length &&
                              cityByParentId.map((item) => (
                                <Select.Option key={item.id} value={item.id}>
                                  <span>{item.locName}</span>
                                </Select.Option>
                              ))}
                          </Select>
                          <ErrorMessage name="city">
                            {(msg) => (
                              <div className="text-[11px] text-red-600 pr-2">
                                {msg}
                              </div>
                            )}
                          </ErrorMessage>
                        </div>
                      </div>
                      <div className="grid grid-cols-10">
                        <div
                          className={` relative ${profileName
                            ? "pointer-events-none opacity-50"
                            : "pointer-events-auto opecity-100"
                            }`}
                        >
                          <label
                            className="file-input__label "
                            htmlFor="picProfile"
                          >
                            <input
                              onChange={(e) => {
                                seveProfilePhotoHandler(e);
                              }}
                              type="file"
                              name="picProfile"
                              id=""
                              className="file-input__input "
                            />
                            <span>عکس پروفایل</span>
                            <img
                              className="absolute"
                              src="/icons/add-square.svg"
                              alt="انتخاب عکس"
                            />
                          </label>
                        </div>
                        <div>
                          {file ? (
                            <img
                              className="rounded-full w-[100px] h-[100px] shadow border "
                              src={file ? file : ""}
                            />
                          ) : (
                            <img
                              className="rounded-full w-[100px] h-[100px] shadow border "
                              src={"./icons/profile.svg"}
                            />
                          )}
                        </div>
                      </div>
                      <div className="grid col-span-1 gap-4 py-2">
                        <div className="flex flex-col border-none outline-none  -mt-1 rounded-xl items-start w-full">
                          <label htmlFor="descraption">توضیحات</label>
                          <Field
                            type="text"
                            name="descraption"
                            className="border-none outline-none  bg-gray-100 rounded-xl w-full p-1"
                          />
                          <ErrorMessage name="descraption">
                            {(msg) => (
                              <div className="text-[11px] text-red-600 pr-2">
                                {msg}
                              </div>
                            )}
                          </ErrorMessage>
                        </div>
                      </div>

                      {/* <div className="grid grid-cols-1 gap-4 py-2">
                        <Checkbox onChange={() => setShowMore(!showMore)}>فعال سازی حساب تجاری</Checkbox>;
                      </div> */}

                      {showMore ? (
                        <>
                          <div className=" b grid grid-cols-4 gap-4  py-2">
                            <div className=" flex col-span-3 flex-col border-none outline-none  p-1 rounded-xl items-start w-full">
                              <label htmlFor="address">ادرس </label>
                              <Field
                                type="text"
                                name="address"
                                className="border-none outline-none  bg-gray-100 rounded-xl w-full p-1"
                              />
                              <ErrorMessage name="address">
                                {(msg) => (
                                  <div className="text-[11px] text-red-600 pr-2">
                                    {msg}
                                  </div>
                                )}
                              </ErrorMessage>
                            </div>
                            <div className="grid col-span-1 gap-4 py-2">
                              <div className="flex flex-col border-none outline-none  -mt-1 rounded-xl items-start w-full">
                                <label htmlFor="map">انتخاب از روی نقشه</label>
                                <input
                                  value={
                                    selectedLocation
                                      ? selectedLocation.address_compact
                                      : ""
                                  }
                                  onClick={showModal}
                                  type="text"
                                  name="map"
                                  className="border-none outline-none  bg-gray-100 rounded-xl w-full p-1"
                                />
                                <ErrorMessage name="map">
                                  {(msg) => (
                                    <div className="text-[11px] text-red-600 pr-2">
                                      {msg}
                                    </div>
                                  )}
                                </ErrorMessage>
                              </div>
                            </div>
                          </div>
                          <div className="grid grid-cols-4 gap-4 py-2">
                            <div className="flex w-full">
                              <div className='flex items-center justify-start w-full gap-6'>
                                <div className="flex flex-col w-full ">
                                  <div className='flex items-center '>
                                    <span class="flex items-center mx-1 mt-2 text-red-500">*</span>
                                    <label for="adsMainCategoryCode" className="block mb-2 text-sm font-medium text-gray-900 ">نوع کسب و کار</label>
                                  </div>
                                  <Field as="select" name="adsMainCategoryCode"
                                    className=" bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 focus:outline-none block w-full p-[1px]">
                                    <option className="rounded-xl overflow-hidden bg-gray-100" value="0">نوع کسب و کار</option>
                                    <option className="rounded-xl overflow-hidden bg-gray-100" value="1">املاک</option>
                                    <option className="rounded-xl overflow-hidden bg-gray-100" value="3">مصالح ساختمانی</option>
                                    <option className="rounded-xl overflow-hidden bg-gray-100" value="2">آهن و فلزات</option>
                                    <option className="rounded-xl overflow-hidden bg-gray-100" value="6">خدمات و نیرو کار ساختمانی</option>
                                    <option className="rounded-xl overflow-hidden bg-gray-100" value="5">تاسیسات و تجهیزات</option>
                                    <option className="rounded-xl overflow-hidden bg-gray-100" value="4">ماشین آلات و ابزار</option>
                                    <option className="rounded-xl overflow-hidden bg-gray-100" value="7">معمار و پیمانکار</option>
                                  </Field>
                                  <ErrorMessage name="adsMainCategoryCode">{msg => <div className='text-[11px] text-red-600 pr-2 block'>{msg}</div>}</ErrorMessage>
                                </div>
                              </div>
                            </div>

                            {/* <div className="flex flex-col ">
                              <label htmlFor="businessType">
                                نوع کسب و کار
                              </label>
                              <Field
                                type="text"
                                name="businessType"
                                className="border-none outline-none bg-gray-100 p-1 rounded-xl"
                              />
                              <ErrorMessage name="businessType">
                                {(msg) => (
                                  <div className="text-[11px] text-red-600 pr-2">
                                    {msg}
                                  </div>
                                )}
                              </ErrorMessage>
                            </div> */}
                            <div className="flex flex-col ">
                              <label htmlFor="businessExpertise">
                                تخصص کسب و کار
                              </label>
                              <Field
                                type="text"
                                name="businessExpertise"
                                className="border-none outline-none bg-gray-100 p-1 rounded-xl"
                              />
                              <ErrorMessage name="businessExpertise">
                                {(msg) => (
                                  <div className="text-[11px] text-red-600 pr-2">
                                    {msg}
                                  </div>
                                )}
                              </ErrorMessage>
                            </div>
                            {/* <div className="flex flex-col border-none outline-none  p-1 rounded-xl items-">
                              <label htmlFor="businessAccountName">
                                نام حساب تجاری *
                              </label>
                              <div className="bg-gray-100 p-1 rounded-xl flex gap-0 items-center justify-between">
                                <Field
                                  type="text"
                                  name="businessAccountName"
                                  className="border-none outline-none  bg-transparent w-[200px]"
                                />
                              </div>
                              <ErrorMessage name="businessAccountName">
                                {(msg) => (
                                  <div className="text-[11px] text-red-600 pr-2">
                                    {msg}
                                  </div>
                                )}
                              </ErrorMessage>
                            </div> */}
                            <div className="flex flex-col ">
                              <label htmlFor="nationalCode">کدملی *</label>
                              <Field
                                type="text"
                                name="nationalCode"
                                className="border-none outline-none bg-gray-100 p-1 rounded-xl"
                              />
                              <ErrorMessage name="nationalCode">
                                {(msg) => (
                                  <div className="text-[11px] text-red-600 pr-2">
                                    {msg}
                                  </div>
                                )}
                              </ErrorMessage>
                            </div>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                      <div className="flex items-center justify-center my-8">
                        <button
                          type="submit"
                          onClick={handleSubmit}
                          className="bg-green-900 text-white w-[20%] text-white py-1 rounded-xl"
                        >
                          ثبت کاربر
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </>
            )}
          </div>
        </div>

        <Modal
          width={1000}
          footer={null}
          title="انتخاب از روی نقشه"
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
        >
          <div className="px-0 py-4">
            <Mapir
              coordinates={[51.41, 35.72]}
              center={coord}
              Map={Map}
              onClick={reverseFunction}
            >
              <Mapir.Marker coordinates={[51.41, 35.72]} anchor="bottom" />
            </Mapir>
            <div className="flex items-center justify-start gap-2">
              <span>موقعیت انتخاب شده: </span>
              <p className="font-bold">
                {selectedLocation
                  ? selectedLocation.address_compact
                  : "موقعیتی انتخاب نکرده اید"}
              </p>
            </div>
            <div className="flex items-center justify-center p-2">
              <button
                onClick={handleCancel}
                className="bg-green-900 text-white w-[20%] text-white py-1 rounded-xl"
              >
                ثبت موقعیت مکانی
              </button>
            </div>
          </div>
        </Modal>
      </Suspense>
    </>
  );
}

const openNotification = () => {
  notification.open({
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="w-6 h-6"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
        />
      </svg>
    ),
    message: "عملیات موفق",
    description: "کاربر با موفقیت ایجاد شد",
  });
};
const formNotCompleted = () => {
  notification.open({
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="w-6 h-6"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
        />
      </svg>
    ),
    message: "اخطار",
    description: "لطفا تمامی اطلاعات لازم را به درستی وارد کنید",
  });
};

export default CreateNewUser;
